import { render, staticRenderFns } from "./FormValidationEvents.vue?vue&type=template&id=5f728d6e&"
import script from "./FormValidationEvents.vue?vue&type=script&lang=js&"
export * from "./FormValidationEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports